module.exports = __webpack_public_path__ + "static/media/Team.8299d635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Team/Team.png
// module id = 346
// module chunks = 0